import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'myApp-abono',
  templateUrl: './abono.component.html',
  styleUrls: ['./abono.component.scss'],
})
export class AbonoComponent implements OnInit {
 @Input() p;
 abono = 0;
  constructor(
              private mdc: ModalController,
  ) { }

  ngOnInit() {}


  agregar(){
    this.mdc.dismiss(
      {
        abono: this.abono
      }
    )
  }

  cerrar(){
    this.mdc.dismiss();
  }
}
